// node_modules/@anacapri/boons/chunks/anacapri-chunk.TDESBC2O.js
var LogHandler = class {
  constructor(logLevel = 1, prefix = "") {
    this.prefix = "";
    this.logLevel = logLevel;
    this.prefix = prefix;
  }
  logError(error) {
    if (console && console.error && this.logLevel >= 1) {
      console.error(this.prefix + error);
    }
  }
  logWarning(warning) {
    if (console && console.warn && this.logLevel >= 2) {
      console.warn(this.prefix + warning);
    }
  }
  logInfo(info) {
    if (console && console.info && this.logLevel >= 3) {
      console.info(this.prefix + info);
    }
  }
  log(message) {
    if (console && console.log && this.logLevel >= 3) {
      console.log(this.prefix + message);
    }
  }
};
var LogHandler_default = LogHandler;

// src/utilities/Logger.ts
var Logger_default = new LogHandler_default(
  parseInt(2),
  `[${"@anacapri/elements"}]: `
);

export {
  LogHandler_default,
  Logger_default
};
